module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Fennel and Ginger.033fd897.webp";